import { useTranslation } from "react-i18next";

export default function TermsOfUse({ isNavOpen }) {
  const { t } = useTranslation();



  return (
    <div className={`${isNavOpen ? "body-squeezed" : "body"}`}>
      <div className="legal-page">

        {/* Title */}
        <h2>{t("terms.title")}</h2>
        <p className="legal-updated">{t("terms.lastUpdated")}</p>

        {/* Intro */}
        <p>{t("terms.intro1")}</p>
        <p>{t("terms.intro2")}</p>
        <p>{t("terms.intro3")}</p>

        {/* 1. Overview */}
        <h3>{t("terms.overview.title")}</h3>
        <p>{t("terms.overview.text1")}</p>
        <ul>
          {t("terms.overview.items", { returnObjects: true }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{t("terms.overview.text2")}</p>

        {/* 2. Eligibility */}
        <h3>{t("terms.eligibility.title")}</h3>
        <ul>
          {t("terms.eligibility.items", { returnObjects: true }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{t("terms.eligibility.note")}</p>

        {/* 3. Accounts */}
        <h3>{t("terms.accounts.title")}</h3>

        <h4>{t("terms.accounts.creation.title")}</h4>
        <p>{t("terms.accounts.creation.text")}</p>

        <h4>{t("terms.accounts.unauthorized.title")}</h4>
        <p>{t("terms.accounts.unauthorized.text")}</p>
        <ul>
          {t("terms.accounts.unauthorized.items", { returnObjects: true }).map(
            (item, i) => (
              <li key={i}>{item}</li>
            )
          )}
        </ul>
        <p>{t("terms.accounts.unauthorized.note")}</p>

        {/* 4. Roles & Admins */}
        <h3>{t("terms.roles.title")}</h3>
        <p>{t("terms.roles.text")}</p>
        <ul>
          {t("terms.roles.items", { returnObjects: true }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>

        {/* 5. User responsibilities */}
        <h3>{t("terms.responsibilities.title")}</h3>
        <p>{t("terms.responsibilities.text")}</p>
        <ul>
          {t("terms.responsibilities.items", { returnObjects: true }).map(
            (item, i) => (
              <li key={i}>{item}</li>
            )
          )}
        </ul>
        <p>{t("terms.responsibilities.note")}</p>

        {/* 6. Content Ownership */}
        <h3>{t("terms.content.title")}</h3>

        <h4>{t("terms.content.user.title")}</h4>
        <p>{t("terms.content.user.text")}</p>
        <ul>
          {t("terms.content.user.items", { returnObjects: true }).map(
            (item, i) => (
              <li key={i}>{item}</li>
            )
          )}
        </ul>

        <h4>{t("terms.content.school.title")}</h4>
        <p>{t("terms.content.school.text")}</p>

        <h4>{t("terms.content.dnzify.title")}</h4>
        <p>{t("terms.content.dnzify.text")}</p>
        <ul>
          {t("terms.content.dnzify.items", { returnObjects: true }).map(
            (item, i) => (
              <li key={i}>{item}</li>
            )
          )}
        </ul>

        {/* 7. Subscription */}
        <h3>{t("terms.subscriptions.title")}</h3>
        <p>{t("terms.subscriptions.text")}</p>

        <h4>{t("terms.subscriptions.refunds.title")}</h4>
        <p>{t("terms.subscriptions.refunds.text")}</p>

        <h4>{t("terms.subscriptions.changes.title")}</h4>
        <p>{t("terms.subscriptions.changes.text")}</p>

        {/* 8. Storage / Media */}
        <h3>{t("terms.storage.title")}</h3>
        <p>{t("terms.storage.text")}</p>
        <ul>
          {t("terms.storage.items", { returnObjects: true }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{t("terms.storage.note")}</p>

        {/* 9. Communications */}
        <h3>{t("terms.comms.title")}</h3>
        <ul>
          {t("terms.comms.items", { returnObjects: true }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{t("terms.comms.note")}</p>

        {/* 10. Privacy */}
        <h3>{t("terms.privacy.title")}</h3>
        <p>{t("terms.privacy.text")}</p>

        {/* 11. Availability */}
        <h3>{t("terms.availability.title")}</h3>
        <p>{t("terms.availability.text")}</p>

        {/* 12. Termination */}
        <h3>{t("terms.termination.title")}</h3>
        <p>{t("terms.termination.text")}</p>
        <ul>
          {t("terms.termination.items", { returnObjects: true }).map(
            (item, i) => (
              <li key={i}>{item}</li>
            )
          )}
        </ul>

        {/* 13. Warranties */}
        <h3>{t("terms.warranty.title")}</h3>
        <p>{t("terms.warranty.text")}</p>

        {/* 14. Liability */}
        <h3>{t("terms.liability.title")}</h3>
        <p>{t("terms.liability.text")}</p>

        {/* 15. Governing Law */}
        <h3>{t("terms.law.title")}</h3>
        <p>{t("terms.law.text")}</p>

        {/* 16. Changes */}
        <h3>{t("terms.changes.title")}</h3>
        <p>{t("terms.changes.text")}</p>

        {/* 17. Contact */}
        <h3>{t("terms.contact.title")}</h3>
        <p>{t("terms.contact.text")}</p>
        <br />
        <p>
          <strong>DNZIFY</strong><br />
          Suite 250 - #1633<br />
          997 Seymour St.<br />
          Vancouver, BC, Canada<br />
          V6B 3M1<br />
          contact@dnzify.com
        </p>


      </div>
    </div>
  );
}
